import React, { useState, useEffect } from 'react';
import { getAdminBankDetails, updateAdminBankDetails, getAdminBankQRCodeUrl } from '../../../controller/agent_data_controller';

export const ManageBankDetails = () => {
    const [bankName, setBankName] = useState('');
    const [accountName, setAccountName] = useState('');
    const [accountNumber, setAccountNumber] = useState('');
    const [ifscCode, setIfscCode] = useState('');
    const [upiId, setUpiId] = useState('');
    const [upiQRCode, setUpiQRCode] = useState(null);
    const [hasQRCode, setHasQRCode] = useState(false);
    const [qrCodePreview, setQrCodePreview] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchDetails = async () => {
            const data = await getAdminBankDetails();
            if (data) {
                setBankName(data.bankName || '');
                setAccountName(data.accountName || '');
                setAccountNumber(data.accountNumber || '');
                setIfscCode(data.ifscCode || '');
                setUpiId(data.upiId || '');
                setHasQRCode(data.hasQRCode || false);
                if (data.hasQRCode) {
                    setQrCodePreview(getAdminBankQRCodeUrl() + '?t=' + new Date().getTime());
                }
            }
        };
        fetchDetails();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const result = await updateAdminBankDetails(bankName, accountName, accountNumber, ifscCode, upiId, upiQRCode);
        if (result === 'success') {
            alert('Bank details updated successfully');
        } else {
            alert('Failed to update bank details: ' + result);
        }
        setLoading(false);
    };

    return (
        <div style={{ padding: '30px' }}>
            <h2 className="services-title">Manage Bank Details</h2>
            <div style={{
                backgroundColor: 'white',
                padding: '30px',
                borderRadius: '12px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                maxWidth: '600px'
            }}>
                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Bank Name:</label>
                        <input
                            type="text"
                            value={bankName}
                            onChange={(e) => setBankName(e.target.value)}
                            required
                            style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc' }}
                        />
                    </div>
                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Account Name:</label>
                        <input
                            type="text"
                            value={accountName}
                            onChange={(e) => setAccountName(e.target.value)}
                            required
                            style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc' }}
                        />
                    </div>
                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Account Number:</label>
                        <input
                            type="text"
                            value={accountNumber}
                            onChange={(e) => setAccountNumber(e.target.value)}
                            required
                            style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc' }}
                        />
                    </div>
                    <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>IFSC Code:</label>
                        <input
                            type="text"
                            value={ifscCode}
                            onChange={(e) => setIfscCode(e.target.value)}
                            required
                            style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc' }}
                        />
                    </div>
                    <div style={{ marginBottom: '25px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>UPI ID (Optional):</label>
                        <input
                            type="text"
                            value={upiId}
                            onChange={(e) => setUpiId(e.target.value)}
                            style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc' }}
                        />
                    </div>
                    <div style={{ marginBottom: '25px' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>UPI QR Code Image:</label>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={(e) => {
                                const file = e.target.files[0];
                                setUpiQRCode(file);
                                if (file) {
                                    setQrCodePreview(URL.createObjectURL(file));
                                }
                            }}
                            style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc' }}
                        />
                        {qrCodePreview && (
                            <div style={{ marginTop: '15px' }}>
                                <p style={{ fontSize: '14px', color: '#666', marginBottom: '8px' }}>Current QR Code Preview:</p>
                                <img 
                                    src={qrCodePreview} 
                                    alt="UPI QR Code" 
                                    style={{ maxWidth: '200px', borderRadius: '8px', border: '1px solid #eee' }} 
                                />
                            </div>
                        )}
                    </div>
                    <button
                        type="submit"
                        disabled={loading}
                        style={{
                            padding: '12px 24px',
                            backgroundColor: '#3765A5',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            cursor: loading ? 'not-allowed' : 'pointer',
                            fontSize: '16px',
                            fontWeight: '500'
                        }}
                    >
                        {loading ? 'Saving...' : 'Save Bank Details'}
                    </button>
                </form>
            </div>
        </div>
    );
};
